export default __webpack_public_path__ + "static/media/pro_aim_puresoft.54d2ec8b.png";